<template>
  <v-container class="yeep-new-service" fluid>
    <div id="content-default" style="position: fixed; z-index: 100; width: -webkit-fill-available">
      <div v-if="vehicle_loading" style="background-color: orange; color: #fff; width: -webkit-fill-available; text-align: center; text-transform: uppercase; padding: 6px">
        <b>Aguarde</b>, buscando dados do veículo...
      </div>

      <div class="header">
        <div @click="returnScreen()" v-if="!vehicle_loading && !description_loading && !media_loading" class="return-screen">
          <v-icon color="white">mdi-close</v-icon>
        </div>
        <div v-if="description_loading" class="return-screen">
          <v-icon color="white">mdi-sync-alert</v-icon>
        </div>
        <div v-if="vehicle_loading && !description_loading" class="return-screen" style="background-color: orange;">
          <v-icon color="white">mdi-sync-alert</v-icon>
        </div>
        <div v-if="media_loading && !vehicle_loading && !description_loading" class="return-screen">
          <v-icon color="white">mdi-upload</v-icon>
        </div>
        <div @click="whatsapp_share.modal = true" class="whatsapp-share mr-3">
          <v-icon color="white">mdi-whatsapp</v-icon>
        </div>
        <h2 @click="openModalEditService">R.S. #{{ service_order.id && service_order.number ? service_order.number : '' }}</h2>
        <div v-if="service_order.id && service_order.service_order_type">
          {{ service_order.vehicle && service_order.vehicle.vehicle_plate ? service_order.vehicle.vehicle_plate + ' - ' : '' }}
          {{ service_order.service_order_type.description.toUpperCase() }}
        </div>
        <div v-else>Aguardando...</div>
      </div>

      <v-tabs
        v-if="app_mode === 'advanced'"
        :show-arrows="false"
        v-model="tab"
        fixed-tabs
        align-with-title
        background-color="#F5F5F5"
        color="#48B38B"
      >
        <v-tabs-slider color="#48B38B"></v-tabs-slider>
        <v-tab style="padding: 0px !important">
          <v-icon>mdi-camera</v-icon>
        </v-tab>
        <v-tab style="padding: 0px !important">
          <v-icon>mdi-file-sign</v-icon>
        </v-tab>
        <v-tab> Detalhes </v-tab>
        <v-tab> Cliente </v-tab>
        <v-tab> Checklist </v-tab>
        <v-tab> Chat </v-tab>
      </v-tabs>

      <div v-else class="checklist-score">
        <div v-if="service_order_score" class="score-emoji">
          {{ service_order_score.emoji }}
        </div>
        <div v-if="service_order_score" class="score-content">
          <div class="pt-1" style="font-size: 14px">
            QUALIDADE DO CHECKLIST: <b>{{ service_order_score.score }} / 100</b>
          </div>
          <div class="py-2">
            <v-progress-linear :color="service_order_score.color" rounded :value="service_order_score.score" height="10"></v-progress-linear>
          </div>
        </div>
      </div>
    </div>

    <div v-if="app_mode === 'advanced'" class="content" :style="vehicle_loading ? { paddingTop: '190px' } : {}">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <Photos ref="servicePhoto" :is-new="!view_service_order_id" @reset-pending-medias="resetPendingMedias" />
        </v-tab-item>
        <v-tab-item>
          <Signatures />
        </v-tab-item>
        <v-tab-item>
          <Details ref="details" :service_order_id="service_order.id" @closeServiceFlow="returnScreenDelete" @changeTab="changeTab" />
        </v-tab-item>
        <v-tab-item>
          <Client @update-vehicle-plate-by-photo="updateVehiclePlateByPhoto" />
        </v-tab-item>
        <v-tab-item>
          <Service />
        </v-tab-item>
        <v-tab-item>
          <ServiceChat v-if="service_order && service_order.id" :serviceOrder="service_order" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else class="content" style="padding: 173px 0px 0px 0px !important">
      <div class="checklist-steps-section">
        <div class="status-checklist">
          <LogsDialog :open="dialog_logs" :logs="logs" :vehicle="service_order.vehicle" @close-dialog="closeDialogLogs" />
          <table v-if="logs" style="width: 100%">
            <tr>
              <td>
                <v-alert
                  @click="dialog_logs = true"
                  v-if="service_status"
                  :color="service_status.color"
                  dark
                  border="left"
                  style="text-transform: uppercase; padding: 4px 16px; margin: 0"
                >
                  <b>{{ service_status.title }}</b> <br />
                  {{ new Date(service_status.created_at).toLocaleDateString() }} às {{ new Date(service_status.created_at).toLocaleTimeString() }}
                </v-alert>
              </td>
              <td width="100px">
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" style="height: 56px" color="primary" depressed outlined block
                      ><v-icon>mdi-list-status</v-icon></v-btn
                    >
                  </template>
                  <v-list>
                    <v-list-item v-for="(status, i) in service_status_select" :key="i" @click="updateServiceStatus(status)">
                      <v-list-item-title v-if="i !== 'created'">{{ status.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <v-expansion-panels @change="scrollToPanel" accordion class="checklist-steps">
        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-icon v-if="score_status(1) === 12" color="primary"> mdi-check-circle </v-icon>
              <v-icon v-if="score_status(1) >= 6 && score_status(1) < 12" color="warning"> mdi-alert </v-icon>
              <v-icon v-if="score_status(1) < 6" color="error"> mdi-alert-circle </v-icon>
            </template>
            <div class="step-number">01</div>
            <div class="step-description">
              <div class="step-description-title">ENTRADA E SAÍDA</div>
              <div class="step-description-content">FOTOS, VÍDEOS E ANEXOS</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <Photos ref="servicePhoto" :is-new="!view_service_order_id" />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-icon v-if="score_status(2)" color="primary"> mdi-check-circle </v-icon>
              <v-icon v-else color="error"> mdi-alert-circle </v-icon>
            </template>
            <div class="step-number">02</div>
            <div class="step-description">
              <div class="step-description-title">DETALHES</div>
              <div class="step-description-content">OBSERVAÇÕES E RESPONSÁVEIS</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-1">
            <Details ref="details" :service_order_id="service_order.id" @closeServiceFlow="returnScreen" @changeTab="changeTab" />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-icon v-if="score_status(3)" color="primary"> mdi-check-circle </v-icon>
              <v-icon v-else color="error"> mdi-alert-circle </v-icon>
            </template>
            <div class="step-number">03</div>
            <div class="step-description">
              <div class="step-description-title">ASSINATURA DO CLIENTE</div>
              <div class="step-description-content">PRESENCIAL OU REMOTA</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4">
            <Signatures />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-icon v-if="score_status(4)" color="primary"> mdi-check-circle </v-icon>
              <v-icon v-else color="error"> mdi-alert-circle </v-icon>
            </template>
            <div class="step-number">04</div>
            <div class="step-description">
              <div class="step-description-title">CHECKLISTS</div>
              <div class="step-description-content">PERSONALIZADOS</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4">
            <Service />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="checklist-steps-section mb-1">
        <v-btn @click="printOS()" outlined color="primary" dark large elevation="0" block>
          <v-icon class="mr-2">mdi-printer</v-icon>
          <span>IMPRIMIR PASTA</span>
        </v-btn>
      </div>

      <div v-if="service_order.vehicle" style="padding: 20px 14px">
        <Client @update-vehicle-plate-by-photo="updateVehiclePlateByPhoto" />
      </div>

      <div class="checklist-steps-section mt-0">
        <v-dialog v-model="dialog_delete">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" outlined large block color="red"> <v-icon class="mr-2">mdi-delete</v-icon> DELETAR CHECKLIST </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey darken-1" style="color: #fff"> Deletar Relatório de serviço </v-card-title>

            <v-card-text class="pt-4">
              Tem certeza que deseja deletar esta R.S. ? Os links compartilhados da R.S. não vão mais funcionar e ela não será incluída nas
              estatísticas e gráficos.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn @click="dialog_delete = false" color="grey darken-1" elevation="0" dark style="width: 60%"> Cancelar </v-btn>
              <v-btn @click="deleteOS()" color="red" elevation="0" dark style="width: 40%"> Deletar R.S. </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <div
      v-if="status === 'finished' || status === 'canceled'"
      style="position: fixed; bottom: 0px; padding: 0 20px; width: 100%; text-align: center; z-index: 100"
    >
      <v-alert color="rgb(219, 219, 219) " border="left"> Relatório de serviço já <b>finalizado</b>. </v-alert>
    </div>

    <v-bottom-sheet v-model="type_service.dialog" persistent>
      <audio v-if="false" controls autoplay style="display: none">
        <source src="@/assets/mp3/buzina.mp3" type="audio/mpeg" />
      </audio>
      <div class="pa-5">
        <div class="mb-3">
          <h2>Selecione o tipo de serviço</h2>
          <v-divider class="my-3"></v-divider>
          <v-alert dark border="left" v-if="!canCreateServiceOrder || osLimitExceededMessage" :color="!canCreateServiceOrder ? 'red' : 'orange'">
            <div v-html="osLimitExceededMessage"></div>
          </v-alert>
          <div class="service-type-list pt-1" v-if="service_order_types">
            <v-btn
              @click="selectTypeService(type_service)"
              v-for="type_service in service_order_types"
              :key="type_service.id"
              outlined
              large
              class="ma-2"
              style="width: -webkit-fill-available"
              :disabled="!canCreateServiceOrder"
            >
              {{ type_service.description }}
            </v-btn>
            <v-btn @click="returnScreen()" outlined large color="red" class="mx-2 mt-5" style="width: -webkit-fill-available"> Cancelar </v-btn>
          </div>
        </div>
      </div>
    </v-bottom-sheet>

    <v-dialog v-model="isLoading" persistent width="300" class="loader-service-order">
      <v-card class="pt-5 pb-2" color="primary" dark>
        <v-card-text>
          Carregando relatório de serviço...
          <v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="whatsapp_share.modal" scrollable width="366">
      <v-card v-if="whatsapp_share.modal">
        <v-card-title class="px-4 pb-3" style="color: rgba(0, 0, 0, 0.6) !important; display: flex; align-items: center; justify-content: center">
          Enviar no WhatsApp
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pt-5 px-5">
          <div v-if="!service_order?.client" class="warning-message">
            <v-icon color="#B7791F">mdi-alert-circle-outline</v-icon>
            <span class="ml-2">Nenhum cliente especificado na OS.</span>
          </div>

          <v-tabs-items v-model="whatsapp_share.tab" touchless>
            <v-tab-item>
              <div class="select-share">
                <div class="text-share">
                  <div class="whatsapp-example" :style="{ 'background-image': `url(${require('@/assets/whats_bg.jpg')})` }">
                    <ul>
                      <li class="me" data-state="read">
                        <span class="time">{{ new Date().getHours() }}:{{ new Date().getMinutes() }}</span>
                        <div style="margin-bottom: 15px" v-html="parseTextWhatsapp"></div>
                      </li>
                      <li class="me" data-state="read">
                        <v-btn @click="whatsapp_share.tab = 1" elevation="0" outlined plain small
                          ><v-icon size="14" class="mr-2">mdi-pencil</v-icon> Editar texto
                        </v-btn>
                      </li>
                      <li class="me" data-state="read">
                        <v-btn @click="whatsapp_share.modal = false" elevation="0" outlined plain small
                          ><v-icon size="14" class="mr-2">mdi-window-close</v-icon> Fechar
                        </v-btn>
                      </li>
                    </ul>
                  </div>
                  <div style="font-size: 12px; margin-top: 14px">
                    No WhatsApp, antes de enviar aguarde 3 segundos para carregar a foto do veículo.
                  </div>
                </div>
                <div @click="shareOS(false)" class="item">
                  <v-icon size="40">mdi-account-circle</v-icon>
                  <div class="sh-title">WhatsApp do Cliente</div>
                </div>
                <div @click="shareOS(true)" class="item">
                  <v-icon size="40">mdi-whatsapp</v-icon>
                  <div class="sh-title">WhatsApp</div>
                </div>
                <div style="width: 100%; float: left; overflow: hidden">
                  <v-tooltip v-model="copy_alert" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="copyLinkOS(`${organization_url?.value || ''}/${getReportPathPrefix()}/${shareServiceOrderHash}`)"
                        v-bind="attrs"
                        v-on="on"
                        color="#8b8b8b"
                        class="mt-3 mb-1"
                        elevation="0"
                        outlined
                        hide-details
                        block
                      >
                        <v-icon size="15px" class="mr-2">mdi-content-copy</v-icon> Copiar link
                      </v-btn>
                    </template>
                    <span>LINK COPIADO!</span>
                  </v-tooltip>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item>
              <v-textarea
                v-model="whatsapp_share.text"
                :disabled="whatsapp_share.loading"
                outlined
                class="mt-1 mb-3"
                height="300px"
                label="Mensagem enviada"
                style="font-size: 14px !important"
                hide-details
              ></v-textarea>
              <small v-html="'As chaves {{CUMPRIMENTAR}}, {{NOME_CLIENTE}} e {{NOME_EMPRESA}} serão substituidas automaticamente.'"></small>
              <div class="mt-4">
                <v-btn @click="whatsapp_share.tab = 0" :disabled="whatsapp_share.loading" elevation="0" outlined style="float: left; width: 30%"
                  >VOLTAR</v-btn
                >
                <v-btn
                  @click="setWhatsappMessage()"
                  :disabled="whatsapp_share.loading"
                  elevation="0"
                  outlined
                  style="float: left; width: calc(70% - 10px); margin-left: 10px"
                  >SALVAR</v-btn
                >
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ModalEditServiceOrder
      :is-active="isModalEditServiceOpen"
      :service-order="service_order"
      :order-types="service_order_types"
      @close="closeModalEditService"
    />
  </v-container>
</template>

<script>
import Median from 'median-js-bridge';
import Photos from '@/components/ServiceOrder/Photos';
import Client from '@/components/ServiceOrder/Client';
import Details from '@/components/ServiceOrder/Details';
import Service from '@/components/ServiceOrder/Service';
import Signatures from '@/components/ServiceOrder/Signatures';
import LogsDialog from '@/components/ServiceOrder/Dialogs/LogsDialog';
import ServiceChat from '@/components/ServiceOrder/Chat/ServiceChat';
import ModalEditServiceOrder from '@/components/ServiceOrder/ModalEditServiceOrder';
import UserTempTokenService from '@/services/api/userTempToken';

export default {
  name: 'Home',
  props: {
    view_service_order_id: Number,
    shouldOpenChat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Photos,
    Signatures,
    Client,
    Details,
    Service,
    LogsDialog,
    ServiceChat,
    ModalEditServiceOrder
  },
  data: () => ({
    tab: 0,
    type_service: {
      dialog: false,
      selected: null
    },
    whatsapp_share: {
      loading: false,
      modal: false,
      tab: 0,
      text: '🚘 {{CUMPRIMENTAR}}, {{NOME_CLIENTE}}! \n \n📋 Vou te encaminhar um relatório de serviço com detalhes e fotos referentes a manutenção executada no seu veículo. \n \n🌟 Você pode nos ajudar a garantir uma experiência cada vez melhor na {{NOME_EMPRESA}} respondendo a avaliação do serviço. \n \n💬 Sua opinião é muito importante para nós! Agradecemos sua participação. \n \nUm abraço da equipe {{NOME_EMPRESA}}!',
      end_text: ''
    },
    organization_url: '',
    copy_alert: false,
    dialog_logs: false,
    dialog_delete: false,
    canCreateServiceOrder: false,
    osLimitExceededMessage: '',
    isModalEditServiceOpen: false
  }),
  async mounted() {
    this.$store.dispatch('ServiceOrder/resetState');
    this.$store.dispatch('ClientClassification/getClientClassifications');
    if (this.view_service_order_id) {
      this.$store.dispatch('ServiceOrder/getServiceOrder', this.view_service_order_id);
    } else {
      this.type_service.dialog = true;
    }
    const reportDomainUrl = this.getReportDomainUrl();
    this.organization_url = { value: reportDomainUrl };
    const user = this.$store.getters['Auth/user'];
    const customOrganizationMessage = user.organization.organization_parameters.find((parameter) => parameter.code === 'WHATSAPP_SHARE_TEXT');
    if (customOrganizationMessage) {
      this.whatsapp_share.text = customOrganizationMessage.value;
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 400);

    this.handleCanCreateServiceOrder();
    if (this.shouldOpenChat) {
      this.tab = 5;
    }
  },
  computed: {
    vehicle_loading() {
      return this.$store.getters['ServiceOrder/isVehicleLoading'];
    },
    media_loading() {
      return this.$store.getters['ServiceOrder/isMediaLoading'];
    },
    description_loading() {
      return this.$store.getters['ServiceOrder/description_loading'];
    },
    app_mode() {
      return localStorage.getItem('app_mode') || 'advanced';
    },
    service_order_score() {
      return this.$store.getters['ServiceOrder/score'];
    },
    service_status_list() {
      return this.$store.getters['General/organization_status_list'];
    },
    service_status() {
      const status = this.service_status_list.find((status) => status.code === this.status);
      const log = this.logs.filter((log) => log.description === this.status).pop();
      return status && log ? { ...status, created_at: log.created_at } : false;
    },
    logs() {
      return this.$store.getters['ServiceOrder/logs'];
    },
    service_status_select() {
      return this.service_status_list.filter((status) => status.ref !== 'created');
    },
    serviceOrderHash() {
      return this.$store.getters['ServiceOrder/hash'];
    },
    shareServiceOrderHash() {
      return this.serviceOrderHash?.replaceAll('-', '');
    },
    isLoading() {
      return this.$store.getters['ServiceOrder/isLoading'];
    },
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    status() {
      return this.$store.getters['ServiceOrder/status'];
    },
    parseTextWhatsapp() {
      return (
        this.whatsapp_share.text
          .replaceAll('\n', '<br>')
          .replaceAll('{{CUMPRIMENTAR}}', this.getWelcomeMessage())
          .replaceAll('{{NOME_EMPRESA}}', `<b>${this.$store.getters['Auth/user']?.organization?.name || ''}</b>`)
          .replaceAll('{{NOME_CLIENTE}}', `<b>${this.service_order.client ? this.service_order.client.name.split(' ')[0] : 'cliente'}</b>`) +
        this.whatsapp_share.end_text.replaceAll('\n', '<br>')
      );
    },
    limit_os() {
      return this.$store.getters['OrganizationServiceOrder/limit_os'];
    },
    service_order_types() {
      return this.$store.getters['OrganizationServiceOrder/service_order_types'];
    },
    service_order_count() {
      return this.$store.getters['OrganizationServiceOrder/service_order_count'];
    }
  },
  methods: {
    getReportDomainUrl() {
      const newReportActive = this.getOrganizationParameter('NEW_REPORT_ACTIVE');
      const isNewReportActive = String(newReportActive).toUpperCase() === 'TRUE';

      if (isNewReportActive) {
        const newReportDomainUrl = this.getOrganizationParameter('NEW_REPORT_ORG_DOMAIN_URL');
        if (newReportDomainUrl) {
          return newReportDomainUrl;
        }
      }

      return this.getOrganizationParameter('ORGANIZATION_DOMAIN_URL');
    },
    getReportPathPrefix() {
      const newReportActive = this.getOrganizationParameter('NEW_REPORT_ACTIVE');
      return String(newReportActive).toUpperCase() === 'TRUE' ? 'servico' : 'os';
    },
    openModalEditService() {
      this.isModalEditServiceOpen = true;
    },
    closeModalEditService() {
      this.isModalEditServiceOpen = false;
    },
    resetPendingMedias(serviceOrderId) {
      this.$emit('reset-pending-medias', serviceOrderId);
    },
    handleCanCreateServiceOrder() {
      const limitOsCourtesy = 5;

      const totalLimit = this.limit_os + limitOsCourtesy;

      if (this.service_order_count >= this.limit_os) {
        if (this.service_order_count >= totalLimit) {
          this.osLimitExceededMessage = `O limite de <b>${totalLimit}</b> serviços do seu plano foi atingido. Entre em contato para saber mais.`;

          this.canCreateServiceOrder = false;
          return;
        }

        this.osLimitExceededMessage = `O limite de <b>${this.limit_os}</b> serviços do seu plano foi atingido. Você ganhou 5 serviços a mais como cortesia. Entre em contato para saber mais.`;
      }

      this.canCreateServiceOrder = true;
    },
    score_status(step) {
      if (!this.service_order || !this.service_order.service_order_photos) {
        return false;
      }

      if (step === 1) {
        const checkMedias = [
          'entry_medias_main',
          'entry_medias_front',
          'entry_medias_right',
          'entry_medias_rear',
          'entry_medias_panel',
          'entry_medias_left',
          'leaving_medias_main',
          'leaving_medias_front',
          'leaving_medias_right',
          'leaving_medias_rear',
          'leaving_medias_panel',
          'leaving_medias_left'
        ];

        const photos = this.service_order.service_order_photos.filter((photo) => checkMedias.includes(photo.tag));
        return photos.length;
        // eslint-disable-next-line no-else-return
      } else if (step === 2) {
        return this.service_order.description && this.service_order.description.length > 0;
      } else if (step === 3) {
        return this.service_order.service_order_signatures.some((signature) => signature.signature_image);
      } else if (step === 4) {
        return this.service_order.service_order_checklists.some((checklist) => checklist.checked_itens_ok > 0);
      }

      return false;
    },
    selectTypeService(type) {
      try {
        if (!this.canCreateServiceOrder) {
          return;
        }

        if (type.id) {
          this.type_service = {
            dialog: false,
            selected: type
          };
          this.$store.dispatch('ServiceOrder/createServiceOrder', type.id);
          this.$store.commit('OrganizationServiceOrder/INCREASE_SERVICE_ORDER_COUNT', 1);
        }
      } catch {
        this.$toast.error('Erro ao cadastrar serviço! Tente novamente');
        this.returnScreen();
      }
    },
    closeDialogLogs() {
      this.dialog_logs = false;
    },
    updateServiceStatus(status) {
      if (status.ref !== 'finished') {
        this.$store.dispatch('ServiceOrder/saveServiceStatus', status);
      } else if (this.$store.getters['ServiceOrder/checklist_warning']) {
        this.$store.dispatch('ServiceOrder/saveServiceStatus', status);
      } else {
        this.$toast.error('Verifique os checklists antes de finalizar');
        this.$store.dispatch('ServiceOrder/updateChecklistWarning', true);
        this.$emit('changeTab', 3);
      }
    },
    returnScreen() {
      this.$emit('return', !this.view_service_order_id);
    },
    returnScreenDelete() {
      this.$emit('returnDelete', true);
    },
    shareOS(bypass) {
      if (this.organization_url) {
        const whatsappMessage = encodeURI(
          this.whatsapp_share.text
            .replaceAll('{{CUMPRIMENTAR}}', this.getWelcomeMessage())
            .replaceAll('{{NOME_EMPRESA}}', `*${this.$store.getters['Auth/user']?.organization?.name || ''}*`)
            .replaceAll('{{NOME_CLIENTE}}', `*${this.service_order.client ? this.service_order.client.name.split(' ')[0] : 'cliente'}*`) +
            this.whatsapp_share.end_text
        );

        if (bypass) {
          window.open(`whatsapp://send?text=${whatsappMessage}`);
        } else if (this.service_order.client) {
          window.open(`whatsapp://send?phone=55${this.service_order.client.phone.match(/\d+/g).join('')}&text=${whatsappMessage}`);
        } else {
          window.open(`whatsapp://send?text=${whatsappMessage}`);
        }
      }

      this.whatsapp_share.modal = false;
    },
    updateVehiclePlateByPhoto(client) {
      this.$refs.servicePhoto.updateVehiclePlateByPhoto(client);
    },
    changeTab(tab) {
      this.tab = tab;
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    getWelcomeMessage() {
      const hours = new Date().getHours();

      if (hours >= 18 && hours < 24) {
        return 'Boa noite';
      }

      if (hours >= 12 && hours < 18) {
        return 'Boa tarde';
      }

      if (hours >= 0 && hours < 12) {
        return 'Bom dia';
      }

      return '--';
    },
    setWhatsappMessage() {
      const self = this;
      self.loading = true;
      self.$http
        .post(`/organization_parameter/whatsapp_message`, {
          value: this.whatsapp_share.text
        })
        .then(() => {
          self.whatsapp_share.loading = false;
          self.whatsapp_share.tab = 0;
          self.$store.dispatch('Auth/setWhatsappMessage', self.whatsapp_share.text);
        })
        .catch(() => {
          self.whatsapp_share.loading = false;
        });
    },
    async copyLinkOS(link) {
      Median.clipboard.set({ data: link });
      this.copy_alert = true;
      setTimeout(() => {
        this.copy_alert = false;
      }, 1500);
    },
    scrollToPanel() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getOrganizationParameter(code) {
      const user = this.$store.getters['Auth/user'];
      const search = user.organization.organization_parameters.find((parameter) => parameter.code === code);
      return search ? search.value : false;
    },
    deleteOS() {
      const self = this;
      self.$store.dispatch('ServiceOrder/setLoading', true);
      self.$http.delete(`/service_order/${self.service_order.id}/disable`).then(() => {
        self.returnScreen();
      });
    },
    async printOS() {
      try {
        let url = `/os/${this.service_order.hash}/pasta`;
        if (this.organization_url?.value?.includes('site.checkmotors.net')) {
          const arrayUrl = this.organization_url.value?.split('/');
          url = `/${arrayUrl[arrayUrl.length - 1]}/os/${this.service_order.hash}/pasta`;
        }

        const response = await UserTempTokenService.create({
          user_id: this.$store.getters['Auth/user']?.id,
          url
        });

        const printUrl = `${this.organization_url.value}/os/${this.service_order.hash}/pasta?force=true&tmp_token=${response.data.token}`;
        window.open(printUrl, '_blank');
      } catch (error) {
        console.error('Erro ao gerar token temporário para impressão:', error);
        window.open(`${this.organization_url.value}/os/${this.service_order.hash}/pasta`, '_blank');
      }
    }
  },
  watch: {
    'whatsapp_share.modal': {
      handler() {
        this.whatsapp_share.tab = 0;
      }
    },
    shareServiceOrderHash: {
      handler(hash) {
        this.whatsapp_share.end_text = `\n ----------------- \n${this.organization_url?.value || ''}/${this.getReportPathPrefix()}/${hash}`;
      }
    }
  }
};
</script>

<style lang="scss">
.yeep-new-service {
  padding: 0px 0px 90px 0px !important;

  .loader-service-order {
    background-color: #48b38b;
    box-shadow: none !important;
  }

  .header {
    padding: 20px 20px;
    background-color: #eeeeee;

    .return-screen {
      float: right;
      background-color: #c7c7c7;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }

    .whatsapp-share {
      float: right;
      background-color: #48b38b;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }

  .content {
    padding: 150px 20px 20px 20px;

    .box {
      .add {
        text-align: center;
        border: 1px dashed rgba(0, 0, 0, 0.4);
        border-radius: 4px;
        padding: 10px 20px;
      }
    }
  }

  .v-tabs--fixed-tabs > .v-tabs-bar .v-tab {
    margin-left: 0px !important;
  }

  .v-slide-group__prev,
  .v-slide-group__next {
    display: none !important;
  }
}

.checklist-score {
  background-color: #f5f5f5;
  padding: 10px 20px;
  font-size: 13px;
  overflow: hidden;
  border-bottom: 3px solid #e5e5e5;

  .score-emoji {
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 50px;
    background-color: #fff;
    margin-right: 12px;
    border-radius: 6px;
    font-size: 28px;
  }

  .score-content {
    float: left;
    width: calc(100% - 62px);
  }
}

.checklist-steps {
  border-top: 4px solid #e5e5e5;
  border-bottom: 4px solid #e5e5e5;

  h3 {
    color: rgba(0, 0, 0, 0.6) !important;
  }

  .v-expansion-panel::before {
    box-shadow: none !important;
  }

  .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
    flex: none;
  }

  .v-expansion-panel-header {
    background-color: #f5f5f5;

    .step-number {
      font-weight: bold;
      background-color: #e7e7e7;
      border-radius: 6px;
      height: 50px;
      width: 50px;
      font-size: 20px;
      padding: 15px;
      color: #7d7d7d;
    }

    .step-description {
      color: #7d7d7d;
      margin-left: 15px;

      .step-description-title {
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: bold;
      }

      .step-description-content {
        font-size: 13px;
      }
    }

    .step-status {
    }
  }
}

.checklist-steps-section {
  background-color: #f5f5f5;
  border-top: 3px solid #e5e5e5;
  border-bottom: 3px solid #e5e5e5;
  padding: 14px 24px;
  margin: 20px 0px;
}

.select-share {
  .item {
    float: left;
    border-radius: 5px;
    border: 1px solid #bebebe;
    padding: 10px;
    width: 49%;

    &:nth-child(2) {
      margin-right: 1%;
    }

    &:nth-child(3) {
      margin-left: 1%;
    }

    i {
      width: 100%;
    }

    .sh-title {
      width: 100%;
      margin-top: 3px;
      font-size: 11px;
      text-align: center;
    }
  }
}

.text-share {
  width: 100%;
  float: left;
  overflow: hidden;
  border-bottom: 1px solid #bebebe;
  margin-bottom: 15px;
  padding-bottom: 15px;

  .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0px;
  }

  .whatsapp-example {
    padding: 10px;
    max-height: 300px;
    border-radius: 5px;
    overflow-y: scroll;

    ul {
      width: 100%;
      max-width: 300px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      list-style-type: none;
      padding: 0;
      margin: 0;
      z-index: 10;

      li {
        background: #fff;
        box-shadow: 0 1px 0 0 rgba(#000, 0.1);
        padding: 10px 50px 10px 14px;
        border-radius: 0 10px 10px 10px;
        margin-bottom: 12px;
        position: relative;
        margin-left: 10px;
        max-width: 238px !important;
        padding: 10px !important;

        &:before {
          content: '';
          position: absolute;
          left: -10px;
          top: 0;
          width: 0;
          height: 0;
          border-top: 15px solid #fff;
          border-left: 10px solid transparent;
        }

        .time {
          content: attr(data-time);
          position: absolute;
          right: 10px;
          bottom: 5px;
          font-size: 12px;
          opacity: 0.5;
        }

        .from {
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }

          font-size: 90%;
          display: block;
          margin-bottom: 10px;
          color: #888;

          .phone {
            font-weight: bold;
            margin-right: 8px;
          }
        }

        &.me {
          background: #dcf8c6;
          align-self: flex-end;
          border-radius: 10px 0 10px 10px;
          padding-right: 75px;
          margin-left: 0;
          margin-right: 10px;

          &:before {
            left: auto;
            right: -10px;
            border-top: 15px solid #dcf8c6;
            border-right: 10px solid transparent;
            border-left: 0;
          }

          .time {
            right: 26px;

            &::after {
              font: normal normal normal 24px/1 'Material Design Icons';
              font-size: 15px;
              position: absolute;
              right: -20px;
              bottom: 0;
              top: 4px;
            }
          }

          &[data-state] .time::after {
            content: '\F012D';
            color: #888;
          }
        }

        &.same,
        &.me + .me {
          margin-top: -9px;
        }

        &.single-emoji {
          font-size: 200%;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.warning-message {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fefdde;
  padding: 4px 10px;
  border-radius: 8px;
  bottom: 25px;
  margin: 0 20px 20px 20px;

  span {
    color: #b7791f;
    font-size: 12px;
    font-weight: 500;
  }
}
</style>
